import {ICatalogueExamenWebServiceClient, LigneCatalogueExamenDto} from "@resources/resources";
import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";

@Injectable()
export class DetailExamenResolver implements Resolve<LigneCatalogueExamenDto> {

  constructor(private catalogueExamenWebService: ICatalogueExamenWebServiceClient) {
  }

  resolve(route: ActivatedRouteSnapshot) {
    let idLcsd: number = Number(route.paramMap.get('idLcsd'));
    return this.catalogueExamenWebService.detailExamenByLcsd(idLcsd);
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-examen/digicerba-catalogue-examen-web/src/angular/cerba/src/app/pages/cerba/pages/detail-examen/detail-examen.resolver.ts